import { useCallback, useState } from 'react';

import { hooks } from '@febos-io/common';
import { findExamtList } from '../config';
import { ExamI } from '../types';

export function useDocumentExamListCallback(limit, sort) {
  const [elements, setElements] = useState<ExamI[]>([]);
  const [meta, setMeta] = useState({ total: 0, pages: 0 });

  const { callback, loading } = hooks.useRequestCallback(
    useCallback(
      async (request, filter, page) => {
        const {
          documentos = [],
          total,
          totalPages,
          totalPaginas,
          totalElementos
        } = await request.exec(findExamtList(page, limit, sort, filter));
        setElements(documentos as ExamI[]);
        setMeta({ total: total || totalElementos, pages: totalPages || totalPaginas });
      },
      [limit, sort]
    )
  );

  return {
    loading,
    elements,
    meta,
    callback
  };
}

export default useDocumentExamListCallback;
